import { AppDispatch } from "../../store";
import { startLogout } from "../../store/auth";

import { useDispatch } from "react-redux";

import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

import {
  AppBar, Box, Toolbar, Typography, CssBaseline, useScrollTrigger, Menu, Container, MenuItem, IconButton, Avatar, Tooltip,
} from "@mui/material";
import Button from "@mui/material/Button";
import Cookies from "js-cookie";

import { QrCode, QrCode2, ExpandMore, MenuOutlined,} from "@mui/icons-material";
import { useCheckIsStudent } from "../../hooks";
import { LoadingScreen } from "../../ui/components/LoadingScreen";


interface Props {
  window?: () => Window;
}

type MenuItem = {
  label: string;
  path: string;
  onClick?: () => void;
};



export const PublicMenu: React.FC<Props> = (props) => {

  const dispatch = useDispatch<AppDispatch>();

  const { hasRole: hasPlannerRole, isCheckingRole: isCheckingPlannerRole, error: errorPlanner } = useCheckIsStudent('PLANNER_ROLE');
  const { hasRole: hasUserRole, isCheckingRole: isCheckingUserRole, error: errorUser } = useCheckIsStudent('USER_ROLE');

  const name = Cookies.get("name");
  const email = Cookies.get("email");
  const status = Cookies.get("status");
  const picture = Cookies.get("picture");
  const token = Cookies.get("token");

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: props.window ? props.window() : undefined,
  });

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    dispatch(startLogout());
    handleCloseUserMenu();// Asegúrate de que esta redirección refleje el nuevo estado
  };



  let settings = [];
  if (isCheckingPlannerRole || isCheckingUserRole) {
    // Mientras se están verificando los roles, puedes mostrar un spinner o algún indicador de carga
    return <LoadingScreen />;
  } else {
    if (token && status === "authenticated") {
      if (hasPlannerRole) {
        settings.push({ label: "Panel Administrativo", path: "/planner" });
      }
      if (hasUserRole || hasPlannerRole) {
        settings.push({ label: "Mi Cuenta", path: "/account/me" });
      }
      settings.push({
        label: "Cerrar Sesión",
        onClick: handleLogout,
        path: "/"
      });
    } else {
      settings = [
        { label: "Iniciar sesión", path: "/auth/login" },
        { label: "Registrarse", path: "/auth/register" }
      ];
    }
  }

  return (
    <>
      <CssBaseline />

      <AppBar
        position="sticky"
        elevation={trigger ? 4 : 0}
        sx={{
          py: 0,
          backgroundColor: trigger ? "#fff" : "#04082B",
          transition: "0.3s", // suaviza la transición del cambio de color// cambia el color de fondo cuando hay scroll
        }}
      >
        <Container maxWidth={"xl"}>
          <Toolbar disableGutters>
            {/* BOTON DE LOGO PARA WEB */}
            <QrCode2
              sx={{
                display: { xs: "none", md: "flex" },
                mr: 1,
                color: trigger ? "#04082B" : "#ffff",
              }}
            />

            <Typography
              variant="h6"
              noWrap
              component={RouterLink}
              to={`/`}
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                /* fontFamily: 'monospace',
                fontWeight: 700, */
                fontFamily: "Montserrat",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: trigger ? "#04082B" : "#ffff",
                textDecoration: "none",
              }}
            >
              TICOTICKET
            </Typography>

            {/* BOTON DE LOGO para mobile*/}

            <Typography
              variant="h5"
              noWrap
              component={RouterLink}
              to={`/`}
              sx={{
                mr: 2,
                display: { xs: "flex", md: "none" },
              }}
            >
              {" "}
              <QrCode
                sx={{
                  display: { xs: "flex", md: "none" },
                  mr: 1,
                  color: trigger ? "#04082B" : "#ffff",
                }}
              />
            </Typography>


            <Box sx={{ flexGrow: 0, marginLeft: "auto" }}>
              <Tooltip title="Open settings">
                {token && status === "authenticated" ? (
                  <Button
                    onClick={handleOpenUserMenu}
                    sx={{
                      textTransform: "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Avatar alt=" nombre usuario " src={picture} />
                      <Box
                        sx={{
                          marginLeft: 2,
                          marginRight: 2,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Typography color="white" variant="subtitle1">
                          {name}
                        </Typography>
                        <Typography fontSize={12} color="white" variant="body2">
                          {email}
                        </Typography>
                      </Box>
                      <ExpandMore
                        sx={{ color: trigger ? "#04082B" : "#ffff" }}
                      />
                    </Box>
                  </Button>
                ) : (
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <MenuOutlined
                      sx={{ color: trigger ? "#04082B" : "#ffff" }}
                    />
                  </IconButton>
                )}
              </Tooltip>

              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting.label}
                    onClick={() => {
                      handleCloseUserMenu();
                      setting.onClick && setting.onClick();
                    }}
                    component={RouterLink}
                    to={setting.path}
                  >
                    <Typography>{setting.label}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};
